<div class="dialog-container" [style]="getDialogContainerStyles()">
  <input type="text" class="header-input" [disabled]="isLoading()" [placeholder]="data.searchPlaceholder || 'Filter options'" [(ngModel)]="filterText" />
  <div *ngIf="isLoading()" class="options skeleton">
    <div *ngFor="let option of [1,2,3,4,5,6,7,8,9]" class="option">
      <span class="primary-text skeleton-animation"></span>
      <span class="secondary-text skeleton-animation"></span>
    </div>
  </div>
  <div *ngIf="!isLoading()" class="options">
    <div *ngIf="filteredOptions.length == 0" class="empty">
      <span class="empty-state">{{getEmptyText()}}</span>
    </div>
    <div *ngFor="let option of filteredOptions" class="option selectable" [ngClass]="{selected: isSelected(option)}"  [title]="getOptionTitle(option)" (click)="select(option)">
      <span class="primary-text">{{data.getPrimaryDisplayValue(option)}}</span>
      <span *ngIf="data.getSecondaryDisplayValue && data.getSecondaryDisplayValue(option)" class="secondary-text">{{data.getSecondaryDisplayValue(option)}}</span>
    </div>
  </div>
  <div class="footer-buttons">
    <button mat-button class="button text-button secondary" (click)="cancel()">{{data.cancelText || 'Cancel'}}</button>
    <button mat-button class="button text-button" [disabled]="!canConfirm()" (click)="confirm()">{{data.confirmText || 'Confirm'}}</button>
  </div>
</div>
